<template>
  <!-- 直接促销设置 -->
  <div class="wrapper max-width">
    <NetworkError @retryClick="init" v-if="isNetError"></NetworkError>
    <loading v-else-if="isLoading" />
    <div class="content" v-else>
      <div class="header">
        <div class="sale-content">
          {{ $t('saleContent') }}
        </div>
        <div class="switch-wrapper">
          <span class="sale">{{ $t('notAgreeSale') }}</span>
          <div
            class="switch"
            @click="saleSwitch"
            :class="[isChecked ? 'switch-checked' : 'switch-unchecked']"></div>
        </div>
      </div>
      <p class="tips">
        {{ $t('authorizationTips') }}
      </p>
      <div class="next-button">
        <div class="next-button-text" @click="nextStep">
          {{ nextBtnText }}
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { DialogBox, NetworkError, Loading } from '@/components/index'
import { setNaviMenu, closeSelf, openPrivateURL } from '@/utils/nativeBridge'
import utils from '@/utils/utils'
import pages from '@/config/pages'

const { confirmContent } = pages
const { getUrlQuery, getUrl, setHtmlTitle } = utils

export default {
  name: 'SaleSetting',
  components: {
    NetworkError,
    Loading
  },
  data () {
    return {
      isLoading: false,
      isNetError: false,
      isChecked: false,
      params: {},
      nextBtnText: this.$t('confirm')
    }
  },
  mounted () {
    this.init()
  },
  methods: {
    init () {
      this.initParams()
      this.initNative()
    },
    initParams () {
      const params = getUrlQuery(true)
      this.params = params
      this.params.optout = Number(this.isChecked)
    },
    initNative () {
      setHtmlTitle(this.$t('title_sale'))
      setNaviMenu([{
        position: 'left',
        title: '',
        iconId: 'icon_navi_back',
        event: 'applicationDetailClose',
        callBack: closeSelf
      }])
    },
    saleSwitch () {
      if (!this.isChecked) {
        DialogBox({
          content: this.$t('saleTips'),
          cancelText: this.$t('cancel'),
          confirmText: this.$t('confirm')
        })
          .then(() => {
            this.isChecked = !this.isChecked
            this.params.optout = Number(this.isChecked)
          })
          .catch(err => {
            throw new Error(err)
          })
      } else {
        this.isChecked = !this.isChecked
        this.params.optout = Number(this.isChecked)
      }
    },
    nextStep () {
      const url = getUrl(confirmContent, this.params, true)
      openPrivateURL(url)
    }
  }
}
</script>

<style scoped lang="scss">
@import "./index.scss"
</style>
